(() => {
  let enable_free_product_for_sell_price = document.querySelector('.enable_free_product_for_sell_price');
  window.getGiftConfig = () => {
    const tag = document.querySelector('[id^="gift-config-"]');
    if (!tag) {
      console.log('[GIFT-PROMO] No <script id="gift-config-*"> tag found – aborting.');
      return null;
    }

    try {
      const cfg = JSON.parse(tag.textContent);
      console.log('[GIFT-PROMO] Config loaded:', cfg);
      return cfg;
    } catch (err) {
      console.error('[GIFT-PROMO] Failed to parse config JSON:', err);
      return null;
    }
  };

  window.promo = getGiftConfig();
  if (promo && promo.giftIds && promo.giftIds.length) {

    const THEME_EVENTS = ['cart:updated', 'theme:cart:change', 'cart:update'];
     window.initialCheck=()=>{
      fetch('/cart.js')
        .then(r => r.json())
        .then(checkGiftRule)
        .catch(console.error);
    }

     window.wireThemeEvents=()=>{
      THEME_EVENTS.forEach(evt =>
        document.addEventListener(evt, e => {
          const cart = e?.detail?.cart;
          if (cart) {
            console.log(`[GIFT-PROMO] Received “${evt}”`, cart);
            checkGiftRule(cart);
          }
        })
      );
    }

    window.wireBulletPubSub=()=>{
      try {
        if (typeof window.bulletThemeSubscribe === 'function' && window.BULLET_THEME_PUB_SUB_EVENTS?.cartUpdate) {
          window.bulletThemeSubscribe(window.BULLET_THEME_PUB_SUB_EVENTS.cartUpdate, ({ data, source }) => {
            if (source === 'giftPromoRefresh') return;
            const cart = data?.cart;
            if (cart) checkGiftRule(cart);
          });
        }
      } catch (err) {
        console.error('[GIFT-PROMO] Bullet subscribe failed:', err);
      }
    }

     window.wireFallbackFormListener=()=>{
      document.addEventListener('submit', e => {
        const form = e.target;
        if (form.matches('form[action^="/cart/add"]')) {
          setTimeout(() => {
            fetch('/cart.js')
              .then(r => r.json())
              .then(checkGiftRule)
              .catch(console.error);
          }, 500);
        }
      });
    }

     window.checkGiftRule=(cart)=> {
      const realProducts = cart.items.filter(item => !promo.giftIds.includes(item.id));
      let real_pro_total_qty = 0;
      realProducts.forEach((pro)=>{
        real_pro_total_qty += pro.quantity;
      })
      console.log("realProducts",real_pro_total_qty);
      const freeGiftIds = promo.giftIds.map(giftId => {
        const giftLine = cart.items.find(i => i.id == giftId);
        return {
          giftId,
          inCart: Boolean(giftLine),
          meetsQty: promo.thresholdQty ? real_pro_total_qty >= promo.thresholdQty : false,
          meetsPrice: promo.thresholdPrice ? cart.total_price >= parseFloat(promo.thresholdPrice) : false
        };
      });
      console.log("freeGiftIds",freeGiftIds);
      const removeIds = [];
      freeGiftIds.forEach(rule => {
        if (rule.inCart && !(rule.meetsPrice || rule.meetsQty)) removeIds.push(rule.giftId);
       });
      if(removeIds.length){
        const updates = {};
        removeIds.forEach(id => updates[id] = 0);
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ updates })
        })
        .then(r => {
          refreshCart();
        })
        .then(cart => console.log('Updated cart', cart))
        .catch(e => console.error(e));
      }
      let giftAdded = false;

      realProducts.forEach(item => {
        if (giftAdded) return;        
        if(enable_free_product_for_sell_price.dataset.status=='false'){
                  let session_storage_item = sessionStorage.getItem(`pro_json_data_${item.handle}`);
                  if(session_storage_item){
                      let session_storage_item_json = JSON.parse(session_storage_item);
                      const variant = session_storage_item_json.variants.find(v => v.id == item.variant_id);
                      const hasCompare = Boolean(variant?.compare_at_price);

                      if (!hasCompare && !giftAdded) {
                        giftAdded = true;
                        freeGiftIds.forEach(rule => {
                          if (!rule.inCart && (rule.meetsPrice || rule.meetsQty)) addGift(rule.giftId);
                        });
                      }
                  }else{
                  fetch(`/products/${item.handle}.js`)
                    .then(r => r.json())
                    .then(product => {
                      sessionStorage.setItem(`pro_json_data_${product.handle}`,JSON.stringify(product));
                      const variant = product.variants.find(v => v.id == item.variant_id);
                      const hasCompare = Boolean(variant?.compare_at_price);

                      if (!hasCompare && !giftAdded) {
                        giftAdded = true;
                        freeGiftIds.forEach(rule => {
                          if (!rule.inCart && (rule.meetsPrice || rule.meetsQty)) addGift(rule.giftId);
                        });
                      }
                    })
                    .catch(() => {
                      if (!giftAdded) {
                        giftAdded = true;
                        freeGiftIds.forEach(rule => {
                          if (!rule.inCart) addGift(rule.giftId);
                        });
                      }
                    });
                  } 
        }else{
           if (!giftAdded) {
              giftAdded = true;
              freeGiftIds.forEach(rule => {
                if (!rule.inCart && (rule.meetsPrice || rule.meetsQty)) addGift(rule.giftId);
              });
            }
        }
      });

       window.clearCart=()=> {
        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => fetch('/cart.js'))
          .then(r => r.json())
          .then(cart => {
            if (window.CartJS?.cart?.update) {
              window.CartJS.cart.update(cart);
            } else if (typeof window.bulletThemePublish === 'function' && window.BULLET_THEME_PUB_SUB_EVENTS?.cartUpdate) {
              window.bulletThemePublish(window.BULLET_THEME_PUB_SUB_EVENTS.cartUpdate, { source: 'giftPromoRefresh', data: { cart } });
            } else {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
              if (window.Shopify?.onCartUpdate) window.Shopify.onCartUpdate(cart);
            }

            // const counterEl = document.querySelector('.cartCounter [data-count]');
            // if (counterEl) {
            //   counterEl.setAttribute('data-count', '0');

            //   const hiddenSpan = counterEl.querySelector('.visually-hidden');
            //   if (hiddenSpan) hiddenSpan.textContent = '0';
            // }
            const counterEl = document.querySelector('.cartCounter [data-count]');
              if (counterEl) {
                const count = cart.item_count;
                if (count == 0) {
                  counterEl.setAttribute('data-count', '');
                } else {
                  counterEl.setAttribute('data-count', count);
                }
                const hiddenSpan = counterEl.querySelector('.visually-hidden');
                if (hiddenSpan) {
                  hiddenSpan.textContent = count;
                }
              }
          })
          .catch(console.error);
      }

      function addGift(giftId) {
        promo._addingGifts = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: giftId, quantity: 1 })
        })
          .then(refreshCart)
          .catch(e => {
            console.error('[GIFT-PROMO] Failed to add gift:', giftId, e);
            refreshCart();
          });
      }

      function removeGift(lineKey) {
        if (!lineKey) return;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        })
          .then(refreshCart)
          .catch(e => {
            console.error('[GIFT-PROMO] Failed to remove gift:', e);
            refreshCart();
          });
      }

      function fixGiftQuantities(cart) {
        cart.items.forEach(item => {
          if (promo.giftIds.includes(item.id) && item.quantity > 1) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 1 })
            })
              .then(refreshCart)
              .catch(console.error);
          }
        });
      }

      function refreshCart() {
        return fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {

             /* ================= UPDATE CART COUNT ================= */
          const counterEl = document.querySelector('.cartCounter [data-count]');
          if (counterEl) {
            const count = cart.item_count;
            if (count == 0) {
              counterEl.setAttribute('data-count', '');
            } else {
              counterEl.setAttribute('data-count', count);
            }
            const hiddenSpan = counterEl.querySelector('.visually-hidden');
            if (hiddenSpan) {
              hiddenSpan.textContent = count;
            }
          }
          /* ================= UPDATE CART COUNT ================= */

            if (window.CartJS?.cart?.update) {
              window.CartJS.cart.update(cart);
            } else if (typeof window.bulletThemePublish === 'function' && window.BULLET_THEME_PUB_SUB_EVENTS?.cartUpdate) {
              window.bulletThemePublish(window.BULLET_THEME_PUB_SUB_EVENTS.cartUpdate, { source: 'giftPromoRefresh', data: { cart } });
            } else {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
              if (window.Shopify?.onCartUpdate) window.Shopify.onCartUpdate(cart);
            }

            document.dispatchEvent(new CustomEvent('giftPromo:cartUpdated', { detail: { cart } }));
            checkGiftRule(cart);
            fixGiftQuantities(cart);
          })
          .catch(error => console.error('[GIFT-PROMO] Error in refreshCart:', error));
      }
    }

    initialCheck();
    wireThemeEvents();
    wireBulletPubSub();
    wireFallbackFormListener();
  }
})();


(function() {
  const oldOpen = window.XMLHttpRequest.prototype.open;

  window.XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
    try {
      // Detect cart-related XHR requests
      if (
        typeof url === 'string' &&
        /cart.*js|cart\/change|cart\/add/.test(url) &&
        !/\/cart\.js\?currency=|\/cart\.js\?bundle|\/cart\.js\?src=ss|\/cart\.json\?icu=1/.test(url)
      ) {
        this.addEventListener('load', () => {
          if (typeof window.initialCheck === 'function') {
            window.initialCheck(); 
          }
        });
      }
    } catch (err) {
      console.warn('[GIFT-PROMO] Failed to hook XHR:', err);
    }

    return oldOpen.apply(this, arguments);
  };
})();
